import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { ShelfcaseService } from '../../../service/shelfcase/shelfcase.service';
import { LocaService } from '../../../service/loca/loca.service';
import { AbcService } from '../../../service/abc/abc.service';
import { LocaBlockService } from '../../../service/loca-block/loca-block.service';
import { TypeColdService } from '../../../service/type-cold/type-cold.service';
import { TypeStockService } from '../../../service/type-stock/type-stock.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9125',
  templateUrl: 'wa9125.component.html',
  styleUrls: ['wa9125.component.scss']
})
export class Wa9125Component implements OnInit {
  public componentTitle = 'WA9125:ロケマスタ什器単位修正';

  public abcs: any;
  public locablocks: any;
  public typecolds: any;
  public typestocks: any;
  public owners: any;
  public shelfcases: any;

  public whCd: FormControl;
  public floorCd: FormControl;
  public areaCd: FormControl;
  public lineCd: FormControl;
  public shelfCd: FormControl;
  public ownerId: FormControl;
  public shelfcaseId: FormControl;

  public layercountNr = 0;
  public ordercountNr = 0;

  public typecoldCd: FormControl;
  public typestockCd: FormControl;
  public locablockCd: FormControl;
  public locaabcId: FormControl;

  public notarriveFl = 0;
  public notshipFl = 0;

  public ownerTx = null;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private loca = null;

  private isTypestockCdClassActive = false;
  private isTypecoldCdClassActive = false;
  private isLocaBlockCdClassActive = false;
  private isLocaAbcIdClassActive = false;
  private isUpdateButtonEnabled = false;

  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private shelfcaseService: ShelfcaseService,
    private locaService: LocaService,
    private abcService: AbcService,
    private locaBlockService: LocaBlockService,
    private typeColdService: TypeColdService,
    private typeStockService: TypeStockService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {

    (this.whCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric2)])),
      (this.floorCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric1)])),
      (this.areaCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric3)])),
      (this.lineCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric1)])),
      (this.shelfCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric2)])),
      (this.shelfcaseId = new FormControl('', [Validators.required])),
      (this.ownerId = new FormControl('', [Validators.required])),
      (this.typestockCd = new FormControl('', [Validators.required])),
      (this.typecoldCd = new FormControl('', [Validators.required])),
      (this.locablockCd = new FormControl('', [Validators.required])),
      (this.locaabcId = new FormControl('', [Validators.required]));
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;

    // TODO should be execute parallel, but API server don't work properly
    this.typeStockService
      .get()
      .then(outputJson => {
        //console.log(JSON.stringify(outputJson));
        this.typestocks = outputJson.typestocks;
        this.typeColdService
          .get()
          .then(_outputJson => {
            //console.log(JSON.stringify(_outputJson));
            this.typecolds = _outputJson.typecolds;
            this.locaBlockService
              .get()
              .then(__outputJson => {
                //console.log(JSON.stringify(__outputJson));
                this.locablocks = __outputJson.locablocks;
                this.abcService
                  .get()
                  .then(___outputJson => {
                    //console.log(JSON.stringify(___outputJson));
                    this.abcs = ___outputJson.abcs;
                    this.ownerService
                      .get()
                      .then(____outputJson => {
                        //console.log(JSON.stringify(____outputJson));
                        this.owners = ____outputJson.owners;
                        this.shelfcaseService
                          .get()
                          .then(______outputJson => {
                            this.working = false;
                            //console.log(JSON.stringify(______outputJson));
                            this.shelfcases = ______outputJson.shelfcases;
                          })
                          .catch(error => {
                            this.working = false;
                            this.errorInfo = this.commonService.getErrorMessage(error);
                          });
                      })
                      .catch(error => {
                        this.working = false;
                        this.errorInfo = this.commonService.getErrorMessage(error);
                      });
                  })
                  .catch(error => {
                    this.working = false;
                    this.errorInfo = this.commonService.getErrorMessage(error);
                  });
              })
              .catch(error => {
                this.working = false;
                this.errorInfo = this.commonService.getErrorMessage(error);
              });
          })
          .catch(error => {
            this.working = false;
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    if (!this.isUpdateButtonEnabled)
      return;

    var whCd = this.whCd.value.trim();
    var floorCd = this.floorCd.value.trim();
    var areaCd = this.areaCd.value.trim();
    var lineCd = this.lineCd.value.trim();
    var shelfCd = this.shelfCd.value.trim();

    let errors = false;
    if (this.whCd.errors !== null) {
      this.whCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.floorCd.errors !== null) {
      this.floorCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.areaCd.errors !== null) {
      this.areaCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.lineCd.errors !== null) {
      this.lineCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shelfCd.errors !== null) {
      this.shelfCd.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shelfcaseId.errors !== null) {
      this.shelfcaseId.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (this.typestockCd.errors !== null) {
      this.typestockCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typecoldCd.errors !== null) {
      this.typecoldCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locablockCd.errors !== null) {
      this.locablockCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locaabcId.errors !== null) {
      this.locaabcId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    this.working = true;

    this.locaService
      .putLocashelf(
        whCd + floorCd + areaCd + lineCd + shelfCd,
        this.typestockCd.value,
        this.typecoldCd.value,
        this.locablockCd.value,
        this.locaabcId.value,
        this.notarriveFl,
        this.notshipFl,
        'wa9125'
      )
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    if (sessionStorage.getItem('baseUrlCompany') === null) {
      this.router.navigate([
        JSON.parse(sessionStorage.getItem('loginResult')).user.roleId === 3  
        ? 'wa0003' : 'wa0002']);
      return;
    }

    const loca: object = JSON.parse(sessionStorage.getItem('loca'));
    this.loca = loca;
    console.log(this.loca);

    var whCd = loca['whCd'];
    var floorCd = loca['floorCd'];
    var areaCd = loca['areaCd'];
    var lineCd = loca['lineCd'];
    var shelfCd = loca['shelfCd'];
    var shelfcaseId = loca['shelfcaseId'];
    var ownerId = loca['ownerId'];

    var typestockCd = loca['typestockCd'];
    var typecoldCd = loca['typecoldCd'];
    var locablockCd = loca['locablockCd'];
    var locaabcId = loca['locaabcId'];
    var arrivepriorityNr = loca['arrivepriorityNr'];
    var shippriorityNr = loca['shippriorityNr'];
    this.notarriveFl = loca['notarriveFl'];
    this.notshipFl = loca['notshipFl'];
    this.ownerTx = loca['ownerTx'];

    this.whCd.setValue(whCd);
    this.floorCd.setValue(floorCd);
    this.areaCd.setValue(areaCd);
    this.lineCd.setValue(lineCd),
    this.shelfCd.setValue(shelfCd);
    this.shelfcaseId.setValue(shelfcaseId);
    this.ownerId.setValue(ownerId);
    this.typestockCd.setValue(typestockCd);
    this.typecoldCd.setValue(typecoldCd);
    this.locablockCd.setValue(locablockCd);
    this.locaabcId.setValue(locaabcId);

    this.isTypestockCdClassActive = false;
    this.isTypecoldCdClassActive = false;
    this.isLocaBlockCdClassActive = false;
    this.isLocaAbcIdClassActive = false;
  }

  /** Input Changed */
  onTypestockCdChanged() {
    this.isTypestockCdClassActive = this.typestockCd.value !== this.loca['typestockCd'];
    this.checkUpdateButtonState();
  }

  onTypecodeCdChanged() {
    this.isTypecoldCdClassActive = this.typecoldCd.value !== this.loca['typecoldCd'];
    this.checkUpdateButtonState();
  }

  onLocaBlockCdChanged() {
    this.isLocaBlockCdClassActive = this.locablockCd.value !== this.loca['locablockCd'];
    this.checkUpdateButtonState();
  }

  onLocaABCIdChanged() {
    this.isLocaAbcIdClassActive = this.locaabcId.value !== this.loca['locaabcId'];
    this.checkUpdateButtonState();
  }

  onRadioGroupChange() {
    this.checkUpdateButtonState();
  }


  checkUpdateButtonState() {
    this.isUpdateButtonEnabled =
        this.isTypestockCdClassActive  ||
        this.isTypecoldCdClassActive  ||
        this.isLocaBlockCdClassActive  ||
        this.isLocaAbcIdClassActive ||
        (this.notarriveFl != this.loca['notarriveFl']) ||
        (this.notshipFl != this.loca['notshipFl']);
  }

  cancel() {
    sessionStorage.removeItem('loca');
    this.closeButtonClick.emit(false);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9125/wa9125.component.ts